<div>
    <ul class="list-group">
        @if (svg) {
            <div>
                <button type="button" class="btn btn-link" (click)="removeQr()" [title]="qrBackLabel()">
                    <fa-icon [icon]="qrBackIcon"></fa-icon> {{ qrBackLabel() }}
                </button>
            </div>
            <div [innerHTML]="svg" class="d-flex justify-content-center"></div>
        } @else {
            @for (barcode of identifiedBarcodes(); track barcode.id) {
                <li class="list-group-item d-flex justify-content-between align-items-start">
                    <div>
                        <!-- barcode details -->
                        <div class="fw-bold pb-2">{{ barcode.label }}</div>
                        <div class="d-flex flex-wrap align-items-baseline gap-1 small">
                            <code [title]="barcode.barcode">{{ barcode.barcodeDisplayString }}</code>
                            <time
                                [attr.datetime]="barcode.timestamp"
                                class="fw-light fst-italic whitespace-nowrap"
                                [title]="barcode.timestamp"
                                >{{ barcode.timestamp | date: 'medium' }}</time
                            >
                        </div>
                    </div>
                    <div class="d-flex gap-1">
                        <!-- actions-->
                        @if (qrableBarcodes()) {
                            <button
                                type="button"
                                class="btn btn-primary"
                                (click)="qrizeBarcode(barcode)"
                                [title]="qrTitle()"
                                [attr.aria-label]="qrTitle()"
                            >
                                <fa-icon [icon]="qrIcon"></fa-icon>
                            </button>
                        }
                        @if (pickableBarcodes()) {
                            <button
                                type="button"
                                class="btn btn-primary"
                                (click)="pickBarcode(barcode)"
                                [title]="barcode.matchesPattern ? pickTitle() : mismatchTooltip()"
                                [attr.aria-label]="pickTitle()"
                                [disabled]="!barcode.matchesPattern"
                                [tooltip]="barcode.matchesPattern ? '' : mismatchTooltip()"
                            >
                                <fa-icon [icon]="pickIcon"></fa-icon>
                            </button>
                        }
                        @if (deletableBarcodes()) {
                            <button
                                type="button"
                                class="btn btn-danger"
                                (click)="deleteBarcode(barcode.id)"
                                [title]="deleteTitle()"
                                [attr.aria-label]="deleteTitle()"
                            >
                                <fa-icon [icon]="deleteIcon"></fa-icon>
                            </button>
                        }
                    </div>
                </li>
            }
        }
    </ul>
</div>
